import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const TrackPage = lazy(() => import("@/pages/track.page"));

export const Route = createFileRoute("/track")({
  component: TrackPage,
});
